export default __webpack_public_path__ + "pgnv-assets/589a984c3d2d88bb2847ffaebf2d0af8.svg";